<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="4">
            <el-form-item label="试卷名称">
              <el-autocomplete class="inline-input" v-model="searchParams.name" :fetch-suggestions="queryPName"
              @select="list"   placeholder="请输入内容"></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="类型">
              <select-option-dictionary @change="list" v-model="searchParams.type" :clearable="false" dkey="exp-type">
              </select-option-dictionary>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="创建人">
              <el-input v-model="searchParams.tname" @change="list"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="科目">
              <el-input placeholder="请选择科目" disabled v-model="sbname">
                <template slot="append">
                  <el-button type="primary" @click="selectSub()">{{ sbname ? '重新选择' : '选择' }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="" style="display: inline-block; margin-left: 10px">
              <el-switch v-model="searchParams.popIdx" active-color="#13ce66" inactive-color="#ff4949"
                @change="list">
              </el-switch>
              <span style="margin-left: 5px">阶段过关试卷</span>
            </el-form-item>
          </el-col>
          <div class="search-btn">
            <el-button type="success" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button @click="clearSearchVal">清空</el-button>
          
          </div>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="toSave()">添加</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        <el-table-column type="selection" width="50" fixed="left"></el-table-column>
        <!-- 根据视图类型决定列的顺序 -->
        <template v-if="isStandardView">
          <el-table-column prop="sbname" width="220" label="科目"></el-table-column>
          <el-table-column prop="name" label="试卷名称"></el-table-column>
          <el-table-column prop="subId" width="150" label="试卷序号"></el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="name" label="试卷名称"></el-table-column>
          <el-table-column prop="sbname" width="220" label="科目"></el-table-column>
        </template>
        <el-table-column prop="type" width="100" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">个人补考</span>
            <span v-if="scope.row.type == 1">小测随考</span>
            <span v-if="scope.row.type == 2">通用卷</span>
            <span v-if="scope.row.type == 3">阶段评测</span>
            <span v-if="scope.row.type == 4">体验摸底</span>
            <span v-if="scope.row.type == -1">覆盖卷</span>
            <el-tag size="mini" type="danger" title="支持移动端" v-if="scope.row.isMobile == 1">移</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="duration" width="75" label="时长"></el-table-column>
        <el-table-column prop="score" width="90" label="及格/总分">
          <template slot-scope="scope">
            {{ scope.row.passScore }} / {{ scope.row.score }}
          </template>
        </el-table-column>

        <el-table-column prop="status" width="60" label="状态">
          <template slot-scope="scope">
            <p v-if="scope.row.status == 1">启用</p>
            <p v-if="scope.row.status == 2">不启用</p>
          </template>
        </el-table-column>
        <el-table-column prop="dbColumn_crer" width="80" label="创建人"></el-table-column>
        <el-table-column prop="crtm" width="110" label="创建时间"></el-table-column>
        <!-- <el-table-column prop="mark" label="备注"></el-table-column> -->
        <el-table-column label="操作" fixed="right" width="300px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" @click="toDetail(scope.$index, scope.row)">详情
              </el-button>
              <el-button size="mini" @click="toUpdate(scope.$index, scope.row)">编辑
              </el-button>
              <el-button size="mini" type="danger" v-if="me.role == 'ad' || me.id == scope.row.crer"
                @click="remove(scope.$index, scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <edit ref="edit"></edit>
    <edtails ref="edtails"></edtails>
    <!-- 科目列表 -->
    <el-dialog title="选择科目" :visible.sync="dialogVisible" width="60%" :append-to-body="true">
      <tree class="filter-tree" ref="permissionTree" check-strictly :items="permissionList" :data="permissionList"
        :defaultParent="0" @nodeClick="treeClick" :expand-on-click-node="true"> </tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmSub">选定科目</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 在 import 部分添加科目 API
import subApi from '@/api/edu/subject/subject.js'
import tree from '@/components/tree/tree.vue'

import edit from './edit.vue';
import api from '@/api/exams/exampaper/exampaper.js';
import edtails from './edtails.vue';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue'

export default {
  name: 'exampaper',
  components: {
    edit, edtails, selectOptionDictionary, tree
  },
  data() {
    return {
      searchParams: {
        status: undefined,
        subjectId: undefined //科目ID
      },
      sbname: '', // 科目名称显示
      dialogVisible: false, // 科目选择弹窗开关
      permissionList: [], // 科目树数据
      subData: {}, // 选中的科目信息

      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      // 添加标准视图相关数据
      isStandardView: false,
      standardListData: [],
      selected: [],
      page: new this.$constant.pageObj(),
      me: "", //操作人
    };
  },
  watch: {
    /*"searchParams.name": function () {
      this.search();
    }*/
  },
  methods: {

    selectSub() {
      this.dialogVisible = true;
      // 强制刷新
      setTimeout(() => {
        this.permissionList = JSON.parse(JSON.stringify(this.permissionList));
      }, 100);
    },

    treeClick(data) {
      this.subData = data;
    },

    comfirmSub() {
      this.sbname = this.subData.name;
      this.searchParams.subjectId = this.subData.id;
      this.dialogVisible = false;
      this.list(); // 选择科目后自动刷新列表
    },

    // 获取科目树数据
    getSubjectTree() {
      subApi.list({}, response => {
        if (response && response.code === 1000 && response.data) {
          this.permissionList = response.data;
        }
      },error => {
       // console.error('获取科目列表失败:', error);
        this.$message.error('获取科目列表失败');
      });
    },

    // 清空搜索条件时也清空科目选择
    clearSearchVal() {
      this.searchParams = {
          // 保持与后端默认逻辑一致
      };
      this.sbname = ''; // 清空科目名称显示
      this.subData = {}; // 清空选中的科目数据
    //  console.log('清空搜索条件，重置为默认参数:', this.searchParams);
      this.list();
    },


    queryPName(queryStr, cb) {
      //发起查询
      api.intionlist({ name: queryStr }, res => {
        let listPapers = res.data
        var results = queryStr ? listPapers.filter(this.createFilterPN(queryStr)) : listPapers;
        // 调用 callback 返回建议列表的数据
        cb(results);
      })
    },
    createFilterPN(queryStr) {
      return (listPapers) => {
        return (listPapers.value.indexOf(queryStr) >= 0);
      };
    },
    //获取数据
    list() {
      this.listLoading = true;
      //console.log('开始获取试卷列表，参数:', this.searchParams, '分页:', this.page);

      // 合并搜索参数和分页参数
      let params = Object.assign({}, this.searchParams, this.page);
     // console.log('合并后的请求参数:', params);

      api.list(params, (response) => {
       // console.log('试卷列表接口返回结果:', response);
        if (response && response.code === 1000 && response.data) {
          this.listData = response.data;
         // console.log('试卷列表数据:', this.listData);

          // 如果是标准视图，更新标准视图数据
          if (this.isStandardView) {
        //    console.log('当前为标准视图，加载标准视图数据');
            this.$nextTick(() => {
              this.loadStandardViewData();
            });
          }
        } else {
         // console.error('返回数据格式不正确:', response);
          this.$message.error(response.msg || '获取数据失败，返回格式不正确');
        }
        this.listLoading = false;
      }, (error) => {
       // console.error('获取试卷列表失败:', error);
        this.listLoading = false;
        this.$message.error('获取试卷列表失败: ' + (error.message || '未知错误'));
      });
    },
    //去添加
    toSave() {
      this.$refs.edit.open({}, '添加试卷', false, '80%');

    },
    toUpdate(index, row) {
      let editParameter = {
        id: row.id
      };
      this.$refs.edtails.open(editParameter, '编辑试卷', false, '80%');
    },
    toDetail(index, row) {
      let detailParameter = {
        id: row.id
      };
      this.$refs.edtails.open(detailParameter, '试卷详情', true, '80%');
    },

    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id
      }
      this.$utils.confirm.warning('提示', '确定删除试卷吗？', () => {
        api.remove(
          parameter,
          response => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          response => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info('请选择至少一行');
        return;
      }
      let parameter = {
        ids: this.selected
      };
      this.$utils.confirm.warning('提示', '确定删除吗？', () => {
        api.remove({
          ids: this.selected
        },
          response => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          response => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search() {
      this.page.current = 1
      this.list();
    },
    //处理视图切换
    handleViewChange(val) {
      //console.log('标准试卷视图切换到:', val);
      if (val) {
        this.loadStandardViewData();
      } else {
        // 切换回普通视图时，使用备用排序方法确保按创建时间排序
        this.useFallbackStandardData();
      }
    },

    //加载标准视图数据
    loadStandardViewData() {
     // console.log('开始加载标准视图数据');
      this.listLoading = true;

      // 使用新的接口按试卷序号排序
      api.listByOrder({}, (response) => {
       // console.log('标准视图接口返回结果:', response);
        if (response && response.code === 1000 && response.data) {
         // console.log('标准视图数据加载成功:', response.data.length, '条记录');

          // 验证数据是否已正确排序
          //console.log('后端返回的前几条数据:', response.data.slice(0, 3));

          // 直接使用后端排序好的数据
          this.standardListData = response.data;

          // 添加验证日志
          if (this.standardListData.length > 0) {
          //  console.log('第一条数据的subId:', this.standardListData[0].subId);
           // console.log('最后一条数据的subId:', this.standardListData[this.standardListData.length - 1].subId);
          }
        } else {
        //  console.warn('标准视图接口返回空数据或错误，使用备用数据');
          this.useFallbackStandardData();
        }
        this.listLoading = false;
      }, (error) => {
        //console.log('标准视图数据加载失败，使用备用排序方式:', error);
        this.useFallbackStandardData();
        this.listLoading = false;
      });
    },

    // 备用标准数据加载方法
    useFallbackStandardData() {
     // console.log('使用备用标准数据排序方法');
      //console.log('当前listData:', this.listData);

      if (this.listData && this.listData.records && this.listData.records.length > 0) {
        // 创建数据副本进行排序
        const sortedData = [...this.listData.records];

        // 标准试卷视图：按模块ID排序，再按科目ID排序，最后按试卷序号(subId)升序排列
        if (this.isStandardView) {
          sortedData.sort((a, b) => {
            // 先按模块ID排序
            if (a.moduleId && b.moduleId) {
              if (a.moduleId < b.moduleId) return -1;
              if (a.moduleId > b.moduleId) return 1;
            }

            // 再按科目ID排序
            if (a.subjectId && b.subjectId) {
              if (a.subjectId < b.subjectId) return -1;
              if (a.subjectId > b.subjectId) return 1;
            }

            // 最后按试卷序号(subId)升序排列
            if (a.subId && b.subId) {
              // 对于subId这类可能很长的数字字符串，我们需要进行适当的比较
              // 首先比较长度
              if (a.subId.length !== b.subId.length) {
                return a.subId.length - b.subId.length;
              }
              // 长度相同时按字典序比较
              if (a.subId < b.subId) return -1;
              if (a.subId > b.subId) return 1;
            }

            // 如果没有序号，则按创建时间降序排列
            if (a.crtm && b.crtm) {
              return new Date(b.crtm) - new Date(a.crtm);
            }

            return 0;
          });
        }
        // 普通视图：按创建时间降序排列
        else {
          sortedData.sort((a, b) => {
            // 按创建时间降序排列
            if (a.crtm && b.crtm) {
              return new Date(b.crtm) - new Date(a.crtm);
            }

            return 0;
          });
        }

        this.standardListData = sortedData;
        //console.log('使用备用排序数据:', sortedData.length, '条记录');
        if (sortedData.length > 0) {
         // console.log('排序后的前几条数据:', sortedData.slice(0, 3));
        }
      } else {
        this.standardListData = [];
       // console.warn('无可用数据进行备用排序');
      }
    },

  },
  mounted() {

    this.getSubjectTree()
    // 初始化时设置默认type过滤值，与后端默认逻辑保持一致
    // 后端默认type > 1，前端设置type = 2作为初始值
    if (!this.searchParams.type && this.searchParams.type !== 0) {
         this.searchParams.type = null  ;
    }

    //console.log('试卷管理页面挂载，初始搜索参数:', this.searchParams);
    this.list();
    this.me = this.$caches.user.get();

    // 监听路由变化，确保页面状态正确
    this.$nextTick(() => {
      //console.log('试卷管理页面已挂载');
      // 如果初始就是标准视图，确保正确排序
      if (this.isStandardView) {
        this.$nextTick(() => {
          this.loadStandardViewData();
        });
      }
    });
  },
}
</script>
<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
